import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SnackbarProvider from "./components/snackbar/SnackbarProvider";

import { initAnalyticsFromApi } from "@ecommerce/analytics";
import { HttpAxiosRequest } from "./http";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <SnackbarProvider>
      <App />
    </SnackbarProvider>
  </React.StrictMode>
);

(async () => {
    await initAnalyticsFromApi(HttpAxiosRequest);
})();














